/* src/app/pages/ui-kit/components/data-list-view/data-list-view.component.scss */
.demo {
  display: grid;
  gap: 24px;
}
/*# sourceMappingURL=data-list-view.component.css.map */
